import { Component, Input, OnInit } from '@angular/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { MemberCard, MemberCardQuery } from '@fgb/core';
import { KidTypeE, KidTypeT } from 'src/app/shared/utilities/age-ranges';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-home-page-banner',
  templateUrl: './home-page-banner.component.html',
  styleUrls: ['./home-page-banner.component.scss'],
})
export class HomePageBannerComponent implements OnInit {
  screenSize = ScreenType;
  KidType = KidTypeE;

  @Input() isKid: boolean;
  @Input() isClub1901: boolean;
  @Input() isSTHMember: boolean;
  @Input() memberInfo: { firstName: string; kidType: KidTypeT };

  card$: Observable<MemberCard | undefined>;

  constructor(private memberCardQuery: MemberCardQuery) {}

  ngOnInit() {
    this.card$ = this.memberCardQuery.selectCurrentCard();
  }
}
